import { calculateEditorialCoverage } from '../utils/academicMetrics';
export const COURSES = [];
export const TOPICS = [];
export const BLOCKS = [];
export const SUBJECTS = [];
export const MODULES = [];
export const LESSONS = [];
export const QUESTIONS = [];
export const FLASHCARDS = [];
export const MIND_MAPS = [];
export const QUICK_REVIEWS = [];
export const MATERIALS = [];
export const MUSIC = [];
export const EXAM_TEMPLATES = [];
export const COURSE_STATUS_LABELS = { draft: 'Rascunho', building: 'Em construção', active: 'Ativo', closed: 'Encerrado', archived: 'Arquivado' };

export const getCourse = slug => COURSES.find(item => item.slug === slug);
export const getSubject = (courseId, slug) => SUBJECTS.find(item => item.courseId === courseId && item.slug === slug);
export const getLesson = id => LESSONS.find(item => item.id === id);
export const getCourseSubjects = courseId => SUBJECTS.filter(item => item.courseId === courseId).sort((a, b) => a.order - b.order);
export const getSubjectModules = subjectId => MODULES.filter(item => item.subjectId === subjectId).sort((a, b) => a.order - b.order);
export const getModuleLessons = moduleId => LESSONS.filter(item => item.moduleId === moduleId && item.published).sort((a, b) => a.order - b.order);
export const getLessonQuestions = lessonId => QUESTIONS.filter(item => item.lessonId === lessonId);
export const getLessonFlashcards = lessonId => FLASHCARDS.filter(item => item.lessonId === lessonId);

export function getNoticeCoverage(courseId) {
  const selectedCourse = COURSES.find(item => item.id === courseId);
  const topics = selectedCourse?.noticeTopics || [];
  if (!selectedCourse?.hasPublishedNotice || topics.length === 0) return null;
  return calculateEditorialCoverage(topics, LESSONS.filter(item => item.courseId === courseId));
}

export function getSubjectNoticeCoverage(courseId, subjectId) {
  const selectedCourse = COURSES.find(item => item.id === courseId);
  const topics = (selectedCourse?.noticeTopics || []).filter(topic => topic.subjectId === subjectId);
  if (!selectedCourse?.hasPublishedNotice || topics.length === 0) return null;
  return calculateEditorialCoverage(topics, LESSONS.filter(item => item.courseId === courseId && item.subjectId === subjectId));
}


export function installCatalog(data = {}) {
  TOPICS.splice(0, TOPICS.length, ...(data.TOPICS || []));
  MATERIALS.splice(0, MATERIALS.length, ...(data.MATERIALS || []));
  MUSIC.splice(0, MUSIC.length, ...(data.MUSIC || []));
  EXAM_TEMPLATES.splice(0, EXAM_TEMPLATES.length, ...(data.EXAM_TEMPLATES || []));
  COURSES.splice(0, COURSES.length, ...(data.COURSES || []));
  BLOCKS.splice(0, BLOCKS.length, ...(data.BLOCKS || []));
  SUBJECTS.splice(0, SUBJECTS.length, ...(data.SUBJECTS || []));
  MODULES.splice(0, MODULES.length, ...(data.MODULES || []));
  LESSONS.splice(0, LESSONS.length, ...(data.LESSONS || []));
  QUESTIONS.splice(0, QUESTIONS.length, ...(data.QUESTIONS || []));
  FLASHCARDS.splice(0, FLASHCARDS.length, ...(data.FLASHCARDS || []));
  MIND_MAPS.splice(0, MIND_MAPS.length, ...(data.MIND_MAPS || []));
  QUICK_REVIEWS.splice(0, QUICK_REVIEWS.length, ...(data.QUICK_REVIEWS || []));
  if(data.TOPICS) COURSES.forEach(course=>{course.noticeTopics=TOPICS.filter(topic=>topic.courseId===course.id&&topic.published!==false);});
}
